export default __webpack_public_path__ + "static/media/slc-012-3699-00.ab9bbd33.jpg";